import * as React from 'react'
import * as Redux from 'react-redux'
import { useLocation } from 'react-router'

import * as layout from '@owl-nest/layout'
import * as model from '@owl-nest/models'

import * as projectModel from '../../../models/project'
import { RootState } from '../../../../reducers'
import * as modalActions from '../../../../actions/modal'

export function PreviewBar(): React.ReactElement<unknown> {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const dispatch = Redux.useDispatch()

  const { search } = useLocation()
  const urlSearchParams = new URLSearchParams(search)
  const previousEditionPath = urlSearchParams.get('prev')

  return (
    <layout.PreviewBar
      previousEditionPath={previousEditionPath ?? `/${project.slug}/`}
      onShare={model.project.isComingSoonEnabled(project) ? () => shareProject() : undefined}
    />
  )

  function shareProject(): void {
    dispatch(modalActions.toggleShareOverlay(true))
  }
}
